export const topMenu = [
  {
    name: "Client Dashboard",
    href: "dashboard",
  },
  {
    name: "Client Reports",
    href: "reports",
    sideBarItems: [
      { name: "Stock Level Audit Report", href: "distribution_audit" },
      { name: "Stores Not Selling Report", href: "distribution_detail" },
      {
        name: "Distribution by Banner by Item",
        href: "distribution_by_banner_by_item",
      },
      {
        name: "Total Distribution by Banner",
        href: "total_distribution_by_banner",
      },
      {
        name: "Stock Level Summary",
        href: "stock_level_summary",
      },
      {
        name: "Monthly Merchandising",
        href: "monthly_merchandising",
      },
      {
        name: "Distribution by Banner by Month",
        href: "banner_by_month",
      },
      {
        name: "Pictures",
        href: "pictures",
      },
      {
        name: "Task Report",
        href: "task_report",
      },
    ],
  },
  {
    name: "System Admin",
    href: "admin",
    sideBarItems: [
      {
        name: "Products",
        href: "products",
        iconName: "Grid",
      },
      {
        name: "Users",
        href: "users",
        iconName: "PersonCircle",
      },
      { name: "Banners", href: "banners", iconName: "Shop", fields: ["name"] },
      {
        name: "Territories",
        href: "territories",
        iconName: "GeoAltFill",
      },
      {
        name: "Stores",
        href: "stores",
        iconName: "BuildingFill",
      },
      {
        name: "Manufacturers",
        href: "manufacturers",
        iconName: "CartCheck",
      },
      {
        name: "Representatives",
        href: "representatives",
        iconName: "PeopleFill",
      },
      {
        name: "Dashboard Configs",
        href: "dashboard-configs",
        iconName: "Sliders",
      },
      {
        name: "Manufacturer Presets",
        href: "manufacturer-presets",
        iconName: "Sliders2",
      },
    ],
  },
  {
    name: "Programs",
    href: "features",
    sideBarItems: [
      { name: "Tasks", href: "tasks", iconName: "ListTask" },
      { name: "Bookings", href: "bookings", iconName: "BagCheck" },
      { name: "Hot Sheets", href: "hot-sheets", iconName: "FileEarmarkText" },
      { name: "Promotions", href: "promotions", iconName: "Flag" },
      { name: "Photo Hashtags", href: "photo-hashtags", iconName: "Hash" },
    ],
  },
  {
    name: "Rep Performance",
    href: "performance",
    sideBarItems: [
      { name: "Call Completion", href: "call_completion" },
      { name: "Rep Distribution", href: "distribution_drop" },
      { name: "Photo Capture Rate", href: "photo_capture" },
      { name: "Store Call Time", href: "call_time" },
      { name: "Rep Report", href: "rep_report" },
      { name: "Visit Report", href: "visit_report" },
    ],
  },
  {
    name: "Log Out",
    href: "logout",
  },
];

export const PROVINCES = [
  { id: 1, name: "Alberta" },
  { id: 2, name: "British Columbia" },
  { id: 3, name: "Manitoba" },
  { id: 7, name: "New Brunswick" },
  { id: 8, name: "Newfoundland" },
  { id: 6, name: "Northwest Territories" },
  { id: 9, name: "Nova Scotia" },
  { id: 12, name: "Ontario" },
  { id: 10, name: "Prince Edward Island" },
  { id: 11, name: "Quebec" },
  { id: 4, name: "Saskatchewan" },
  { id: 5, name: "Yukon" },
];

export const STATUS = [{ name: "ACTIVE" }, { name: "INACTIVE" }];

export const TRUE_FALSE = [{ name: "TRUE" }, { name: "FALSE" }];

export const MANUFACTURER_STATUS = [
  { name: "ACTIVE" },
  { name: "COMPETITOR" },
  { name: "INACTIVE" },
];

export const USER_TYPES = [
  { name: "ADMIN" },
  { name: "MANAGEMENT" },
  { name: "REPORTS" },
  { name: "SYSTEM" },
];

export const MAJOR_GROUPS = [
  { name: "LCL" },
  { name: "Pattison Food Group" },
  { name: "Total Giant Tiger" },
  { name: "Total Metro" },
  { name: "Total Sobeys" },
  { name: "Total Walmart" },
];

export const FORMATS = [
  { name: "g" },
  { name: "kg" },
  { name: "ml" },
  { name: "lb" },
  { name: "l" },
  { name: "pk" },
  { name: "ct" },
  { name: "ca" },
  { name: "un" },
  { name: "oz" },
  { name: "bulk" },
];

export const CLASSIFICATIONS = [
  { name: "AA" },
  { name: "A" },
  { name: "B" },
  { name: "C" },
  { name: "D" },
];

export const QUESTION_TYPES = [
  { id: 1, name: "RADIO" },
  { id: 2, name: "TEXT" },
  { id: 3, name: "CHECK" },
  { id: 4, name: "PHOTO" },
];
